function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: "36.64%",
  x2: "68.475%",
  y1: "0%",
  y2: "124.432%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF1D7"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#D6A85A"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 10.5,
  cy: 10.5,
  r: 10.5,
  fill: "url(#a)",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#000",
  d: "M8.741 7.94h1.042l-1.135 4.886H6.816L5.68 7.94h1.042l.847 4.024h.324L8.74 7.94zm1.689 4.886V7.94h.991v4.886h-.991zm3.85-1.423h-.804v1.423h-.992V7.94h1.796c1.16 0 1.739.566 1.739 1.696 0 .57-.147 1.007-.442 1.311-.294.304-.727.456-1.297.456zm-.804-.848h.797c.493 0 .74-.306.74-.92 0-.3-.06-.518-.18-.65-.12-.131-.306-.197-.56-.197h-.797v1.767z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/icon-vip-profile.2726929c.svg";
export { SvgComponent as ReactComponent };